<template>
    <v-layout column align-center>
      <p class="headline font-weight-bold mb-3 text-center primary--text">
        Selecting the amount of warning you receive
      </p>
      <p class="align-self-start">
        Choose how many minutes ahead of the ETA you want to receive the notifications. Note that in some cases, you may receive the notifications a minute or two late, so give yourself enough time
      </p>
    </v-layout>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
<style scoped>
  >>>img {
    border:1px solid black;
    max-width:100%;
  }

    >>>p {
      margin:0 16px;
    }
    >>>span {
      margin:0 16px;
      text-align:center;
    }

  @media screen and (min-width: 600px) {
    >>>img {
          margin:12px;
    }

  }
</style>
